export interface IControlOptions {
  mapTypeControl: boolean;
  rotateControl: boolean;
  scaleControl: boolean;
  streetViewControl: boolean;
  zoomControl: boolean;
  enableDoubleClickZoom: boolean; // Not Implemented
  draggable: boolean; // Not Implemented
  keyboardShortcuts: boolean; // Not Implemented
  scrollwheel: boolean;
}
